export type CatKey = 'necessary'|'analytics'|'functional'|'marketing';

export type Cat = { 
    key: CatKey; 
    name: string; 
    desc: string; 
    lock?: boolean; 
    val: boolean; 
};

const KEY = 'interim_cookie_prefs_v1';
const CONSENT_KEY = KEY + '_consented';

export const initialCats: Cat[] = [
    {key: 'necessary', name: 'Строго необходимые', desc: 'Работа сайта, безопасность, сеанс.', lock: true, val: true},
    {key: 'analytics', name: 'Аналитика', desc: 'Анонимная статистика и улучшение UX.', val: false},
    {key: 'functional', name: 'Функциональные', desc: 'Запоминание ваших настроек и форм.', val: false},
    {key: 'marketing', name: 'Маркетинговые', desc: 'Персонализация, ретаргетинг.', val: false},
];

export function loadPrefs(): Cat[] {
    if (typeof window === 'undefined') return initialCats;
    try {
        const x = JSON.parse(localStorage.getItem(KEY) || '{}') as Record<CatKey, boolean>;
        return initialCats.map(c => ({
            ...c, 
            val: c.lock ? true : (typeof x[c.key] === 'boolean' ? x[c.key] : c.val)
        }));
    } catch { 
        return initialCats; 
    }
}

export function savePrefs(cats: Cat[]) { 
    if (typeof window !== 'undefined') {
        localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(cats.map(c => [c.key, !!c.val]))));
    }
}

export function needConsent(): boolean { 
    if (typeof window === 'undefined') return false;
    return !localStorage.getItem(CONSENT_KEY); 
}

export function setConsented() { 
    if (typeof window !== 'undefined') {
        localStorage.setItem(CONSENT_KEY, '1');
    }
}